import React, { useEffect, useState } from "react";
import { Gallerys } from "../../../../utils/apis/gallery/Gallery";
import { IDS } from "../../../../utils/common";
import "./Recent.css";
import { useNavigate } from "react-router-dom";

export default function Recent({ categoryId }) {
  const navigate = useNavigate();

  const [galleryData, setGalleryData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const getGallery = async (pageNo = 1, reset = false) => {
    setLoading(true);

    const res = await Gallerys(categoryId, pageNo);

    if (res?.success) {
      const response = res?.data;

      const newData = response?.data || [];

      setGalleryData((prev) => (reset ? newData : [...prev, ...newData]));

      setPage(response?.current_page || 1);
      setTotalPages(response?.total_pages || 1);
    }

    setLoading(false);
  };

  useEffect(() => {
    setGalleryData([]);
    setPage(1);
    setTotalPages(1);
    getGallery(1, true);
  }, [categoryId]);

  const loadMore = () => {
    if (page < totalPages && !loading) {
      getGallery(page + 1);
    }
  };

  const handleRedirect = (id) => {
    navigate(`/gallery-inner/${id}`);
  };

  return (
    <section className="recent-gallery-section">
      <div className="wrapper">
        {(galleryData || [])
          .reduce((rows, item, i) => {
            if (i % 2 === 0) rows.push([item]);
            else rows[rows.length - 1].push(item);
            return rows;
          }, [])
          .map((row, rowIndex) => (
            <div
              className={`gallery-row pattern-${rowIndex % 4}`}
              key={rowIndex}
            >
              {row.map((item) => (
                <div
                  className="gallery-item"
                  key={item.id}
                  onClick={() => handleRedirect(item.id)}
                >
                  <img src={IDS?.IMG_URL + item.image} alt="gallery" />
                </div>
              ))}
            </div>
          ))}

        {/* Load More Button */}
        {page < totalPages && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              onClick={loadMore}
              disabled={loading}
              style={{
                padding: "10px 25px",
                border: "none",
                background: "#000",
                color: "#fff",
                borderRadius: "6px",
                cursor: "pointer",
                boxShadow: "0px 0px 2px #ff0000db",
              }}
            >
              {loading ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
